import { useFormikContext } from 'formik'
import { ManagmentSelector } from '@/shared/selectors'
import { UserSelector } from '@/shared/selectors/user-selector'

export const AccountContactForm = () => {
  const { values, setFieldValue } = useFormikContext()

  return (
    <>
      <ManagmentSelector
        value={values.account_managment_id}
        onChange={(opt) => setFieldValue('account_managment_id', opt?.value || null)}
        isClearable
      />

      <UserSelector
        isMulti
        label="Administrador de contrato"
        role="Administrador de contrato"
        active
        isClearable
        onChange={(options) => {
          const selectedIds = (options || []).map((option) => option.value)
          setFieldValue('user_ids', selectedIds)
          setFieldValue('user_id', selectedIds[0] || null)
        }}
        value={values.user_ids}
      />

    </>
  )
}
